import { sentenceOrPascalToCamel } from "../common";

export const getWorkflowStageKey = (value: string | null | undefined): string =>
  value ? sentenceOrPascalToCamel(value.replace(/[_-]+/g, " ").trim()) : "";
